import { Card, Col, FormLabel, FormText, Row } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import { useState } from 'react';
import IconifyIcon from '../IconifyIcon';
import { Button } from 'react-bootstrap';

const DropzoneFormInput = ({
  label,
  labelClassName,
  helpText,
  iconProps,
  showPreview,
  className,
  text,
  textClassName,
  onFileUpload
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleAcceptedFiles = (acceptedFiles) => {
    const files = acceptedFiles.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    );
    // Only update local state if showPreview is true
    if (showPreview) {
      setSelectedFiles([...selectedFiles, ...files]);
    }
    // Always call onFileUpload callback
    if (onFileUpload) {
      onFileUpload(files);
    }
  };

  const removeFile = (file) => {
    const newFiles = selectedFiles.filter(f => f !== file);
    setSelectedFiles(newFiles);
    if (file.preview) {
      URL.revokeObjectURL(file.preview);
    }
  };

  const formatBytes = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  return (
    <>
      {label && <FormLabel className={labelClassName}>{label}</FormLabel>}

      <Dropzone onDrop={handleAcceptedFiles} maxFiles={10}>
        {({ getRootProps, getInputProps }) => (
          <>
            <div className={`dropzone dropzone-custom ${className}`}>
              <div className="dz-message" {...getRootProps()} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <input {...getInputProps()} />
                <IconifyIcon
                  icon={iconProps?.icon ?? 'solar:cloud-upload-bold-duotone'}
                  {...iconProps}
                  style={{ display: 'block', margin: '0 auto', ...iconProps?.style }}
                />
                <p className={textClassName} style={{ fontSize: '14px', fontWeight: '400', marginBottom: '8px', marginTop: '12px', textAlign: 'center' }}>{text}</p>
                {helpText && typeof helpText === 'string' ? (
                  <FormText style={{ fontSize: '12px', textAlign: 'center', display: 'block', width: '100%' }}>{helpText}</FormText>
                ) : (
                  helpText
                )}
              </div>
            </div>
            {showPreview && selectedFiles.length > 0 && (
              <div className="dz-preview mt-3">
                {(selectedFiles || []).map((file, idx) => {
                  const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
                  return (
                    <Card className="mt-1 mb-0 shadow-none border" key={idx + '-file'}>
                      <div className="p-2">
                        <Row className="align-items-center">
                          {file.preview ? (
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                className="avatar-sm rounded bg-light"
                                alt={file.name}
                                src={file.preview}
                              />
                            </Col>
                          ) : (
                            <Col className="col-auto">
                              <div className="avatar-sm">
                                <span className="avatar-title bg-primary rounded">
                                  {ext.toUpperCase()}
                                </span>
                              </div>
                            </Col>
                          )}
                          <Col className="ps-0">
                            <div className="text-muted fw-bold">{file.name}</div>
                            <p className="mb-0">
                              <strong>{file.formattedSize}</strong>
                            </p>
                          </Col>
                          <Col className="text-end">
                            <Button
                              variant="link"
                              size="sm"
                              className="text-danger"
                              onClick={() => removeFile(file)}
                            >
                              Delete
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  );
                })}
              </div>
            )}
          </>
        )}
      </Dropzone>
    </>
  );
};

export default DropzoneFormInput;
